import RailsTimeZone from "rails-timezone";

export const formatShortDateTime = (dateString: string | undefined, timezone?: string): string => {
  if (!dateString) return "";
  const date = new Date(dateString);
  if (isNaN(date.getTime())) return "";

  // Convert Rails timezone name to IANA timezone identifier
  let ianaTimezone: string | undefined;
  if (timezone) {
    try {
      ianaTimezone = RailsTimeZone.from(timezone);
    } catch (e) {
      // If conversion fails, fall back to undefined (use browser's local timezone)
      console.warn(`[formatShortDateTime] Failed to convert timezone "${timezone}":`, e);
    }
  }

  const options: Intl.DateTimeFormatOptions = {
    month: "short",
    day: "numeric",
    hour: "numeric",
    minute: "2-digit",
    hour12: true,
    ...(ianaTimezone && { timeZone: ianaTimezone }),
  };
  return date.toLocaleString("en-US", options);
};
